import type { GiftCard } from 'app/typings/giftCard';
import { GiftCardType } from 'app/typings/giftCard';

import { EmailProperties } from '../EmailProperties/EmailProperties';
import { IncentiveProperties } from '../IncentiveProperties/IncentiveProperties';
import { PhysicalProperties } from '../PhysicalProperties/PhysicalProperties';
import { PrintProperties } from '../PrintProperties/PrintProperties';
import { VoucherProperties } from '../VoucherProperties/VoucherProperties';

type Props = {
  giftCard: GiftCard;
};

export const PropertiesContent = ({ giftCard }: Props) => {
  if (
    giftCard.giftCardType === GiftCardType.Voucher ||
    giftCard.giftCardType === GiftCardType.Internal ||
    giftCard.giftCardType === GiftCardType.Manual
  ) {
    return <VoucherProperties giftCard={giftCard} />;
  }

  if (giftCard.giftCardType === GiftCardType.Incentive) {
    return <IncentiveProperties giftCard={giftCard} />;
  }

  if (giftCard.giftCardType === GiftCardType.Email) {
    return <EmailProperties giftCard={giftCard} />;
  }

  if (giftCard.giftCardType === GiftCardType.Physical) {
    return <PhysicalProperties giftCard={giftCard} />;
  }

  return <PrintProperties giftCard={giftCard} />;
};
